export default "__VITE_ASSET__PGUoMxiW__"